/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd. <legal@vecros.com>
 * Proprietary and confidential.
 **********************************************************************************/

/**
 * Assistant chat history client — list / get / delete stored conversations.
 *
 * Backed by the vecros-api endpoints:
 *   GET    /assistant/chats?service=<service>
 *   GET    /assistant/chats/{id}
 *   DELETE /assistant/chats/{id}
 *
 * verify_jwt (Bearer) routes — sends the same token assistantClient.js uses for
 * the chat stream.
 */

import { getAuthToken } from "../../../../../utils/authEnvironment";
import { ASSISTANT_API_BASE, ASSISTANT_SERVICE } from "./assistantClient";

function authHeader() {
  const token = typeof getAuthToken === "function" ? getAuthToken() : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** List the signed-in user's conversations for this service, newest first. */
export async function listChats() {
  const res = await fetch(
    `${ASSISTANT_API_BASE}/assistant/chats?service=${encodeURIComponent(ASSISTANT_SERVICE)}`,
    { headers: { ...authHeader() } },
  );
  if (!res.ok) throw new Error(`Failed to list chats (${res.status})`);
  const data = await res.json();
  return data?.chats || [];
}

/** Full conversation (with messages) for reopening. */
export async function getChat(chatId) {
  const res = await fetch(`${ASSISTANT_API_BASE}/assistant/chats/${chatId}`, {
    headers: { ...authHeader() },
  });
  if (!res.ok) throw new Error(`Failed to load chat (${res.status})`);
  const data = await res.json();
  return data?.chat || null;
}

/** Soft-delete a conversation. */
export async function deleteChat(chatId) {
  const res = await fetch(`${ASSISTANT_API_BASE}/assistant/chats/${chatId}`, {
    method: "DELETE",
    headers: { ...authHeader() },
  });
  if (!res.ok) throw new Error(`Failed to delete chat (${res.status})`);
  return true;
}
